import React from "react";

import { formatDatetimeString } from "../../formatters";
import { EntityProfile } from "../EntityDetail/EntityProfile";

const TopBar = ({ entity, schema, process }) => {
    const descriptionData = {
        Process: process.title,
        "Start Date": formatDatetimeString({ str: process.created }),
        "End Date": formatDatetimeString({ str: process.finished }),
    };

    return (
        <EntityProfile
            entity={entity}
            schema={schema}
            additionalData={descriptionData}
            col={3}
            backLink={`/entities/${entity.key.ulid}/`}
        />
    );
};

export default TopBar;
